import { useState } from "react";
import { useTranslation } from "react-i18next";
import HeroCyberSOC from "./components/HeroCyberSOC";
import Features from "./components/Features";
import Proceso from "./components/Proceso";
import CentroCiberseguridad from "@/pages/home/components/CentroCiberseguridad";
import QuoteModal from "@/components/feature/QuoteModal";
import InfoModal from "@/components/feature/InfoModal";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Navbar from "@/pages/home/components/Navbar";
import InternalCTASection from "@/components/feature/InternalCTASection";
import LandingFooter from "@/components/feature/LandingFooter";
import LanguageTransitionWrapper from "@/components/feature/LanguageTransitionWrapper";

export default function CyberSOCPage() {
  const { t } = useTranslation("common");
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [quoteService, setQuoteService] = useState<string | undefined>(undefined);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const openModal = (type: string) => {
    setModalType(type);
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setTimeout(() => setModalType(null), 300);
  };

  const openQuote = (service?: string) => {
    setQuoteService(service);
    setQuoteOpen(true);
  };
  const closeQuote = () => {
    setQuoteOpen(false);
    setTimeout(() => setQuoteService(undefined), 300);
  };

  return (
    <div className="relative bg-background-950 min-h-screen">
      <Navbar onOpenQuote={openQuote} />

      <LanguageTransitionWrapper>
        <main>
          <HeroCyberSOC onOpenQuote={openQuote} />
          <Features onOpenModal={openModal} />
          <Proceso />
          <CentroCiberseguridad onOpenQuote={openQuote} />

          <InternalCTASection
            tag={t("cs.cta.tag")}
            title={t("cs.cta.title")}
            highlight="CyberSOC de Openlab Secure"
            subtitle={t("cs.cta.subtitle")}
            buttonLabel={t("cs.cta.button")}
            homeButtonLabel={t("cs.cta.homeButton")}
            onQuote={() => openQuote("CyberSOC")}
            image="https://readdy.ai/api/search-image?query=Diverse%20team%20of%20cybersecurity%20analysts%20collaborating%20in%20a%20modern%20security%20operations%20center%2C%20friendly%20and%20focused%2C%20warm%20ambient%20lighting%20mixed%20with%20screen%20glow%2C%20professional%20editorial%20photography%2C%20human%20centered%2C%20cinematic%20depth%20of%20field&width=1600&height=900&seq=cs-cta-human-01&orientation=landscape"
          />
        </main>

        <LandingFooter pageName="CyberSOC 24/7" />
      </LanguageTransitionWrapper>
      <QuoteModal isOpen={quoteOpen} onClose={closeQuote} preselectedService={quoteService} />
      <InfoModal
        isOpen={modalOpen}
        onClose={closeModal}
        modalType={modalType}
        onOpenQuote={(service) => {
          closeModal();
          openQuote(service);
        }}
      />
      <WhatsAppFloat />
    </div>
  );
}